///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.app_switcher = abcsetup.app_switcher || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    abcsetup.app_switcher.init();
    abcsetup.app_switcher.resize();
    $(window).on('resize', () => abcsetup.app_switcher.resize());
});

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.app_switcher = {
    clicked: false,
    animating: false,
    mouseOutTimeout: null,

    // Bind the collapse buttons
    init: function () {
        // Clear any searches
        $('#abcsetup-sidebar').find('#app-search').val('');

        // Hide sidebar when clicking on anything
        $(document).on('mouseup', '*', function () {
            if ($('#abcsetup-sidebar').hasClass('expand')) {
                if ($(this).closest('#abcsetup-sidebar').length) {
                    // This is a bit hacky but it prevents having to use preventDefault which could cause trickle-down problems
                    abcsetup.app_switcher.clicked = true;
                    setTimeout(function() {
                        abcsetup.app_switcher.clicked = false;
                    }, 1000);
                }

                // The click didn't happen on abcsetup-sidebar
                if (!$(this).closest('#abcsetup-sidebar').length && !abcsetup.app_switcher.clicked) {
                    abcsetup.app_switcher.toggleLeftNavs();
                }
            }
        });

        // Auto hide the app-switcher when the mouse leaves after 750ms
        $(document).on('mouseleave', '#abcsetup-sidebar', function () {
            abcsetup.app_switcher.mouseOutTimeout = setTimeout(function() {
                if ($('#abcsetup-sidebar').hasClass('expand')) {
                    abcsetup.app_switcher.toggleLeftNavs();
                }
            }, 750);
        });

        // App switcher mouse enter event - reset the autohide timeout
        $(document).on('mouseenter', '#abcsetup-sidebar', function () {
            clearTimeout(abcsetup.app_switcher.mouseOutTimeout);
        });

        // A link within the app switcher was clicked
        $(document).on('click', '#abcsetup-sidebar a:not(.btn-toggle, .pin-btn, .nav-title)', function () {
            abcsetup.app_switcher.toggleLeftNavs();
        });

        // App switcher toggle clicked
        $(document).on('click', '.sidebarCollapse', function () {
            // Un-pin (if needed)
            $('#abcsetup-sidebar, #main-content').removeClass('pinned');
            $('#abcsetup-sidebar a.pin-btn').removeClass('active');
            $.cookie("sidebar-pinned", 0);

            abcsetup.app_switcher.toggleLeftNavs();
        });

        // App switcher pin button clicked
        $(document).on('click', '#abcsetup-sidebar a.pin-btn', function () {
            $(this).blur().toggleClass('active');
            $('#abcsetup-sidebar, #main-content').toggleClass('pinned');
            $.cookie("sidebar-pinned", $(this).hasClass('active') ? 1 : 0);
        });

        // App switcher section was exapnded or collapsed
        $(document).on('click', '#abcsetup-sidebar .nav-title', function () {
            const section = $(this).attr('href').replace('#', '');

            setTimeout(function() {
                const expanded = $('#abcsetup-sidebar #' + section).hasClass('show');
                $.cookie("sidebar-" + section, expanded ? 1 : 0);
            }, 1000);
        });

        // The search field had a key pressed
        $(document).on('keyup', '#abcsetup-sidebar #app-search', function () {
            let value = $(this).val().toLowerCase();

            if (value) {
                // Filter down the sections + links to what was typed
                $('#abcsetup-sidebar div.app-panel div:not(.collapse), #abcsetup-sidebar div.app-panel li').filter(function() {
                    const show = $(this).text().toLowerCase().indexOf(value) > -1;
                    $(this).toggle(show).toggleClass('hide', !show);
                });

                // Expand or collapse any sub-sections
                $('#abcsetup-sidebar div.app-panel div.collapse').each(function() {
                    const show = $(this).find('li:not(.hide)').length > 0;
                    $(this).toggleClass('show', show);
                    $('a[data-bs-target="#' + $(this).attr('id') + '"').attr('aria-expanded', show);
                });

            } else {
                // Clear search results and show all links
                $('#abcsetup-sidebar div.app-panel div:not(.collapse), #abcsetup-sidebar div.app-panel li').show().removeClass('hide');
                $('#abcsetup-sidebar div.app-panel div.collapse').removeClass('show');
                $('#abcsetup-sidebar [aria-expanded]').attr('aria-expanded', false);
            }

            // Fix display issues when style-block is applied
            $('#abcsetup-sidebar div.app-panel').find('.col[style*="display: block"], .row[style*="display: block"]').removeAttr('style');
        });

        // Toggle the sub-menu icon
        $(document).on('click', '#abcsetup-sidebar .nav-title', function () {
            $(this).find('#sub-menu-toggle-icon').toggleClass('fa-angle-right fa-angle-down');
        });
    },

    resize: function() {
        // Apply slim scroll to the sidebar
        $('#abcsetup-sidebar .app-panel').slimScroll({
            height: ($(window).height() - 165) + 'px',
            position: 'right',
            railVisible: true,
            alwaysVisible: false,
        });
    },

    toggleLeftNavs: function() {
        if (this.animating) {
            return;
        }

        if ($('#abcsetup-sidebar').hasClass('pinned')) {
            return;
        }

        this.animating = true;

        const show = !$('.sidebarCollapse').hasClass('active');
        $('.sidebarCollapse').blur().toggleClass('active', show);
        $('#abcsetup-sidebar').toggleClass('expand', show);

        setTimeout(function() {
            abcsetup.app_switcher.animating = false;
        }, 500);
    },
};
